import { useTranslation } from 'react-i18next';
import { useOwnConsentsQuery } from '@/hooks/useClientPortal';
import { IntakeFormsCard } from '../IntakeFormsCard';
import { PortalPageHeader } from '../PortalPageHeader';
import { ConsentsSubsection } from './ConsentsSubsection';

export function FormsPage() {
  const { t } = useTranslation('clients');
  const consentsQuery = useOwnConsentsQuery();
  const consents = consentsQuery.data === undefined ? [] : consentsQuery.data;

  return (
    <div className="p-4 sm:p-6 md:p-8">
      <PortalPageHeader
        title={t('portal.pages.forms.title')}
        helperText={t('portal.pages.forms.helper')}
      />
      <div className="space-y-5">
        <IntakeFormsCard />
        <ConsentsSubsection consents={consents} />
      </div>
    </div>
  );
}
